import {
  GET_SKU_MANAGEMENT_FAILURE,
  GET_SKU_MANAGEMENT_REQUEST,
  GET_SKU_MANAGEMENT_SUCCESS,
  GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_FAILURE,
  GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_REQUEST,
  GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS,
  GET_SHIPMENT_REQUEST,
  GET_SHIPMENT_SUCCESS,
  GET_SHIPMENT_FAILURE,
  GET_SKU_BY_ITEMID_REQUEST,
  GET_SKU_BY_ITEMID_SUCCESS,
  GET_SKU_BY_ITEMID_FAILURE,
  GET_SKU_BY_SKUTYPE_REQUEST,
  GET_SKU_BY_SKUTYPE_SUCCESS,
  GET_SKU_BY_SKUTYPE_FAILURE,
  GET_MAPPED_SKU_REQUEST,
  GET_MAPPED_SKU_SUCCESS,
  GET_MAPPED_SKU_FAILURE,
} from "./packagingWorkflowManagementTypes";

const initialStateForSkuManagement = {
  loading: false,
  sku: [],
  error: "",
};

const getSkuManagementReducer = (
  state = initialStateForSkuManagement,
  action
) => {
  switch (action.type) {
    case GET_SKU_MANAGEMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SKU_MANAGEMENT_SUCCESS:
      return {
        loading: false,
        sku: action.payload,
        error: "",
      };
    case GET_SKU_MANAGEMENT_FAILURE:
      return {
        loading: false,
        sku: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForSkuManagementWithoutPagination = {
  loading: false,
  sku: [],
  error: "",
};

const getSkuManagementWithoutPaginationReducer = (
  state = initialStateForSkuManagementWithoutPagination,
  action
) => {
  switch (action.type) {
    case GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS:
      return {
        loading: false,
        sku: action.payload,
        error: "",
      };
    case GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_FAILURE:
      return {
        loading: false,
        sku: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForShipment = {
  loading: false,
  sku: [],
  error: "",
};

const getShipmentReducer = (state = initialStateForShipment, action) => {
  switch (action.type) {
    case GET_SHIPMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SHIPMENT_SUCCESS:
      return {
        loading: false,
        sku: action.payload,
        error: "",
      };
    case GET_SHIPMENT_FAILURE:
      return {
        loading: false,
        sku: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForSkuByItemId = {
  loading: false,
  sku: [],
  error: "",
};

const getSkuByItemIdReducer = (state = initialStateForSkuByItemId, action) => {
  switch (action.type) {
    case GET_SKU_BY_ITEMID_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SKU_BY_ITEMID_SUCCESS:
      return {
        loading: false,
        sku: action.payload,
        error: "",
      };
    case GET_SKU_BY_ITEMID_FAILURE:
      return {
        loading: false,
        sku: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForSkuBySkuType = {
  loading: false,
  sku: [],
  error: "",
};

const getSkuBySkuTypeReducer = (
  state = initialStateForSkuBySkuType,
  action
) => {
  switch (action.type) {
    case GET_SKU_BY_SKUTYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SKU_BY_SKUTYPE_SUCCESS:
      return {
        loading: false,
        sku: action.payload,
        error: "",
      };
    case GET_SKU_BY_SKUTYPE_FAILURE:
      return {
        loading: false,
        sku: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForMappedSKU = {
  loading: false,
  sku: [],
  error: "",
};

const getMappedSKUReducer = (state = initialStateForMappedSKU, action) => {
  switch (action.type) {
    case GET_MAPPED_SKU_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MAPPED_SKU_SUCCESS:
      return {
        loading: false,
        sku: action.payload,
        error: "",
      };
    case GET_MAPPED_SKU_FAILURE:
      return {
        loading: false,
        sku: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getSkuManagementReducer,
  getSkuManagementWithoutPaginationReducer,
  getShipmentReducer,
  getSkuByItemIdReducer,
  getSkuBySkuTypeReducer,
  getMappedSKUReducer,
};
